module.exports = __webpack_public_path__ + "img/star_1.ae77ce03.jpg";